import { useContext, useMemo } from 'react';

import DraggableEnergy from '@/components/game/3d/physics/DraggableEnergy';
import { ViewContext } from '@/state/contexts';
import { logg } from '@/util/logg';

const EnergyBuilderCarbon = ({
	numCarbon,
	playerId,
	rotato,
	initPos = [3.5, 6, 16.75],
	type = 'carbon',
}) => {
	if (numCarbon <= 0) {
		logg('no carbonies found');
		return null;
	}

	const { paymentMode }: any = useContext(ViewContext);

	const carbonObjects = useMemo(() => {
		const carbons: any[] = [];

		for (let i = 0; i < numCarbon; i++) {
			const energyColor = 'c';
			const color = 'black';
			const homePosition: [number, number, number] = [
				i * 1 + initPos[0],
				initPos[1],
				initPos[2],
			];

			carbons.push({
				id: `${playerId}-${type}-${energyColor}-${i}-${paymentMode}`,
				color,
				energyColor,
				type,
				homePosition,
			});
		}

		return carbons;
	}, [numCarbon, paymentMode]);

	const carbonDisplay = carbonObjects.map((energyObj) => (
		<DraggableEnergy
			key={energyObj.id}
			energy={energyObj}
			rotato={rotato}
		/>
	));

	return (
		<group key={`${type}_energy_group_${playerId}`}>{carbonDisplay}</group>
	);
};

export default EnergyBuilderCarbon;
